export default __webpack_public_path__ + "assets/models/5e7bcfd005ecb137a77bbc0fc2239b68.glb";